import React, { useEffect } from "react";
import CubeLoader from "../CubeLoader/CubeLoader";
import styles from "./SocketLoader.module.css";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../../../lib/constants/routeConstant";
import { setMyAccountActiveTab } from "../../../../redux/slices/publicSlice";
import { connect } from "react-redux";
import myAccountTabsData from "../../../MyAccount/myAccountTabsData";
import cross from '../../../../assets/images/cross.png'

const SocketLoader = ({ failed, changeOrientation, setMyAccountActiveTab }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (failed) {
      const timer = setTimeout(() => {
        navigate(routeConstant.MY_ACCOUNT_PAGE, { replace: true });
        setMyAccountActiveTab(myAccountTabsData[2]?.tabName);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [failed, navigate, setMyAccountActiveTab]);

  if (failed) {
    return (
      <div className={`${styles["loader-container-2"]} ${changeOrientation ? styles["mobile-loader-container"] : ""}`}>
        <img src={cross} alt="" className="max-w-[80px]" />
        <p className="text-center">Connection Failed! Redirecting to My Account Page</p>
      </div>
    );
  }
  
  return (
    <div className={`${styles["loader-container"]} ${changeOrientation ? styles["mobile-loader-container"] : ""}`}>
      <CubeLoader />
      <p className="text-center">Establishing Connection, Please wait...</p>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
    setMyAccountActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
});

export default connect(null, mapDispatchToProps)(SocketLoader);
